export default __webpack_public_path__ + "static/media/lut.fe4089a0.svg";